/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const finalizeTelegramResponseSchema = z.object({
  status: z.enum(['linked', 'switched', 'conflict', 'error']),
  reason: z.string().optional(),
  maskedEmail: z.string().optional(),
  createdAt: z.string().optional(),
  pendingToken: z.string().optional(),
});

export type IFinalizeTelegramResponse = z.infer<typeof finalizeTelegramResponseSchema>;
